import { render, staticRenderFns } from "./PortfolioAlert.vue?vue&type=template&id=4496691e&"
import script from "./PortfolioAlert.vue?vue&type=script&setup=true&lang=js&"
export * from "./PortfolioAlert.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports